export function truckTypeLabel(type: TruckInfo["type"]) {
  switch (type) {
    case "SA":
      return "Sattel";
    case "3A":
      return "Dreiachser";
    case "2A":
      return "Zweiachser";
    case "4A":
      return "Vierachser";
    case "3A4A":
      return "Solo";
    case "HZ":
      return "Hängerzug";
    case "TL":
      return "Tieflader";
    case "KR":
      return "Kran-LKW";
    case "XX":
    default:
      return "kein Typ gewählt";
  }
}
